import { render } from "./PrivacyTermsPage.vue?vue&type=template&id=97ec0722"
import script from "./PrivacyTermsPage.vue?vue&type=script&lang=js"
export * from "./PrivacyTermsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__